import isNumber from 'lodash/isNumber';
import { LabelLayout } from './enum';
export const defaultLabelWidth = 100;
export const defaultLabelLayout = LabelLayout.horizontal;
export const defaultColumns = 1;
export const FIELD_SUFFIX = 'field';
export function normalizeLabelWidth(labelWidth, columns) {
    if (isNumber(labelWidth) || labelWidth === 'auto') {
        return new Array(columns).fill(labelWidth);
    }
    const labelWidths = new Array(columns).fill(defaultLabelWidth);
    labelWidth.slice(0, columns).forEach((width, index) => (labelWidths[index] = width));
    return labelWidths;
}
export function getProperty(props, key, dataSet, record) {
    if (props[key]) {
        return props[key];
    }
    const { name } = props;
    const field = record ? record.getField(name) : dataSet && dataSet.getField(name);
    if (field) {
        const fieldProperty = field.get(key);
        if (fieldProperty) {
            return fieldProperty;
        }
    }
}
export const defaultExcludeUseColonTag = ['div', 'button', 'Button'];
function findFocusableElement(node) {
    if (node.children) {
        let found;
        [...node.children].some(child => {
            if (child.tabIndex > -1) {
                found = child;
            }
            else {
                found = findFocusableElement(child);
            }
            return !!found;
        });
        return found;
    }
}
export function findFirstInvalidElement(node) {
    if (node.children) {
        let found;
        [...node.children].some(child => {
            if (child.className.includes('invalid')) {
                found = findFocusableElement(child);
            }
            else {
                found = findFirstInvalidElement(child);
            }
            return !!found;
        });
        return found;
    }
}
